import { render } from "./wmsos-saida-editar-nova.vue?vue&type=template&id=3cfc0a84&scoped=true"
import script from "./wmsos-saida-editar-nova.vue?vue&type=script&lang=js"
export * from "./wmsos-saida-editar-nova.vue?vue&type=script&lang=js"

import "./wmsos-saida-editar-nova.vue?vue&type=style&index=0&id=3cfc0a84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfc0a84"]])

export default __exports__